<template>
  <Modal title="课程投诉" v-model="visible">
    <Form ref="dataForm" class="form"
          :model="formData" :rules="rule"
          :label-width="80">
      <Row>
        <Col :span="22">
        <Form-item label="投诉理由：" prop="reason">
            <Select v-model="formData.reason" transfer>
              <Option v-for="item in $constant.tchComplaintRemark"
                      :value="item.text">{{ item.text }}</Option>
            </Select>
        </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="上传截图" prop="url">
            <multiple-image-upload :num="100" :defaultFileList="defaultPicList" v-model="formData.url" on-file-change="onFileChange"/>
          </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="备注说明" prop="remark">
            <Input v-model="formData.remark" type="textarea" :rows="3" placeholder="其他必要投诉内容" />
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingAdd" @click="feedBack">确定</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'LessonFeedBackModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      openedId: {
        type: Number
      },
      tchId: {
        type: Number
      },
      uid: {
        type: Number
      },
      userNickname: {
        type: String
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        defaultPicList: [],
        visible: this.value,
        formData: {
          reason: '',
          url: '',
          remark: '',
        },
        loadingAdd: false,
        rule: {
          reason: [
            { type: 'string', required: true, message: '请填写投诉理由', trigger: 'blur' },
          ],
        },
      }
    },
    methods: {
      feedBack () {
        let self = this
        self.loadingAdd = true
        self.$refs.dataForm.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loadingAdd = false
            return
          }
          self.formData.openedId = self.openedId
          self.formData.uid = self.uid
          self.formData.tchId = self.tchId
          self.formData.nickname = self.userNickname
          self.formData.content = self.formData.reason
          self.formData.reason = []
          self.$http.post('/bookLesson/insertLessonFeedBack2', {}, {
            transformRequest: [function (data, headers) {
              return JSON.stringify(self.formData)
            }],
            headers: {'Content-Type': 'application/json;charset=utf-8'},
          }).then(function (res) {
            self.$Message.success('投诉成功!已通知外管处理中')
            self.visible = false
            self.loadingAdd = false
          })
        })
      }
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (val === true) {
          this.formData.reason = ''
          this.formData.userNickname = ''
          this.formData.url = ''
          this.defaultPicList = []
        }
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LessonFeedBackModal.vue?013bcf74